import React, { useState } from 'react';
import ReactPlayer from 'react-player';
import Cookies from 'js-cookie';

import { Form, FormField, FormSubmit, Notice, Modal } from '..';
import { getCountriesAsOptions, getRegionsAsOptions } from '../../../data';
import { submitFeaturedVideoForm } from '../../requests';

const countries = getCountriesAsOptions();

const FeaturedVideo = () => {
  const { formID, videoID } = window;

  const [formSuccess, setFormSuccess] = useState('');
  const [states, setStates] = useState([]);
  const initModalData = {
    modalID: '',
    title: ''
  };

  const [modalData, setModalData] = useState({ ...initModalData });

  const toggleModal = (status, data) => {
    status === true
      ? setModalData({ ...data })
      : setModalData({ ...initModalData });
  };

  const initialValues = {
    firstName: '',
    lastName: '',
    email: '',
    country: '',
    city: '',
    state: '',
    organizationName: '',
    jobTitle: ''
  };

  const convertJSONToUrlEncoded = obj => {
    let str = [];
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        str.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
      }
    }
    return str.join('&');
  };

  const handleSubmit = ({ values, setErrors, setSubmitting }) => {
    setSubmitting(true);
    submitFeaturedVideoForm(formID, convertJSONToUrlEncoded(values))
      .then(res => {
        if ('validation_failed' !== res.status) {
          setFormSuccess(
            'Successfully Submitted! The video will display shortly.'
          );

          Cookies.set('submittedFeaturedVideoForm', true);

          setTimeout(() => {
            toggleModal(true, {
              modalID: 'videoModal',
              title: 'Featured Video'
            });
          }, 500);
        } else {
          setErrors({ formError: res.message });
        }
        setSubmitting(false);
      })
      .catch(({ data }) => {
        setSubmitting(false);
        if (data.message) setErrors({ formError: data.message });
      });
  };

  const handleCountryChange = (event, { values, setValues }) => {
    let states = [];
    const countryShortCode = event.target.value;

    if (countryShortCode) states = getRegionsAsOptions(countryShortCode);

    setStates(states);
    setValues({
      ...values,
      country: countryShortCode,
      state: states && states.length === 1 ? states[0].value : ''
    });
  };

  return (
    <>
      {Cookies.get('submittedFeaturedVideoForm') === 'true' ? (
        <div className="video-modal__player">
          <ReactPlayer
            className="video-modal__frame"
            width="100%"
            height="100%"
            url={`https://www.youtube.com/watch?v=${videoID}`}
          />
        </div>
      ) : (
        <>
          <Form
            className="card"
            onSubmit={handleSubmit}
            initialValues={initialValues}
            render={({
              values,
              errors,
              isSubmitting,
              handleChange,
              setError,
              setValues
            }) => (
              <>
                <div className="card__section">
                  <div className="grid">
                    <div className="grid__col-xs-12 grid__col-md-6">
                      <FormField
                        name="firstName"
                        label="First Name"
                        onChange={handleChange}
                        value={values.firstName}
                        error={errors.firstName}
                        disabled={isSubmitting}
                        className="form__field--required"
                      />
                    </div>
                    <div className="grid__col-xs-12 grid__col-md-6">
                      <FormField
                        name="lastName"
                        label="Last Name"
                        onChange={handleChange}
                        value={values.lastName}
                        error={errors.lastName}
                        disabled={isSubmitting}
                        className="form__field--required"
                      />
                    </div>
                    <div className="grid__col-xs-12">
                      <FormField
                        name="email"
                        label="Email"
                        type="email"
                        onChange={handleChange}
                        value={values.email}
                        error={errors.email}
                        disabled={isSubmitting}
                        className="form__field--required"
                      />
                    </div>
                    <div className="grid__col-xs-12">
                      <FormField
                        name="country"
                        label="Country"
                        type="select"
                        options={countries}
                        emptyOptionLabel="Select a country..."
                        onChange={event =>
                          handleCountryChange(event, { values, setValues })
                        }
                        value={values.country}
                        error={errors.country}
                        disabled={isSubmitting}
                      />
                    </div>
                    <div className="grid__col-xs-12 grid__col-md-6">
                      <FormField
                        name="city"
                        label="City"
                        onChange={handleChange}
                        value={values.city}
                        error={errors.city}
                        disabled={isSubmitting}
                      />
                    </div>
                    <div className="grid__col-xs-12 grid__col-md-6">
                      <FormField
                        name="state"
                        label="State"
                        type="select"
                        options={states}
                        emptyOptionLabel="Select a state..."
                        optionMapKey="label"
                        onChange={handleChange}
                        value={values.state}
                        error={errors.state}
                        disabled={isSubmitting || states.length < 2}
                      />
                    </div>

                    <div className="grid__col-xs-12 grid__col-md-6">
                      <FormField
                        name="organizationName"
                        label="Organization Name"
                        onChange={handleChange}
                        value={values.organizationName}
                        error={errors.organizationName}
                        disabled={isSubmitting}
                        className="form__field--required"
                      />
                    </div>
                    <div className="grid__col-xs-12 grid__col-md-6">
                      <FormField
                        name="jobTitle"
                        label="Job Title"
                        onChange={handleChange}
                        value={values.jobTitle}
                        error={errors.jobTitle}
                        disabled={isSubmitting}
                      />
                    </div>
                  </div>
                </div>

                <hr className="u--margin-0" />

                <div className="card__section">
                  <FormSubmit
                    loading={isSubmitting}
                    disabled={isSubmitting}
                    disabledLabel={
                      isSubmitting && !formSuccess ? 'Submitting...' : 'Submit'
                    }
                  />
                  {errors.formError && (
                    <Notice
                      type="danger"
                      message={errors.formError}
                      dismiss={() => setError('formError', '')}
                    />
                  )}
                  {formSuccess && (
                    <Notice type="success" message={formSuccess} />
                  )}
                </div>
              </>
            )}
          />
          <Modal {...modalData} toggleModal={toggleModal} size="modal--md">
            <div className="video-modal__player">
              <ReactPlayer
                className="video-modal__frame"
                width="100%"
                height="100%"
                url={`https://www.youtube.com/watch?v=${videoID}`}
              />
            </div>
          </Modal>
        </>
      )}
    </>
  );
};

export default FeaturedVideo;
